var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.713,
    height: 30.713,
    viewBox: "0 0 30.713 30.713",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_4bdbf1b3edc9f068a4edc8839416c95c",
    "data-name": "4bdbf1b3edc9f068a4edc8839416c95c",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149295",
    "data-name": "Path 149295",
    d: "M16.356,1a15.3,15.3,0,0,0-5.341.955l.445,1.2A14.132,14.132,0,1,1,7.4,5.506V9.958h1.28v-6.4H2.28v1.28H6.2A15.356,15.356,0,1,0,16.356,1Z",
    fill: "#c54c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149296",
    "data-name": "Path 149296",
    d: "M18.28,26.517H17V27.8H27.238v-1.28h-1.28V24.333L23.024,21.4l2.934-2.934V16.28h1.28V15H17v1.28h1.28v2.184L21.214,21.4,18.28,24.333Zm1.28-8.583V16.28h5.119v1.655l-2.559,2.559ZM22.119,22.3l2.559,2.559v1.655H19.559V24.863L22.119,22.3ZM18.28,30.356h1.28v1.28H18.28Zm3.2,0h1.28v1.28h-1.28Zm3.2,0h1.28v1.28h-1.28Z",
    transform: "translate(-5.762 -5.042)",
    fill: "#c54c1f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/pendingIcon.8ed84394ea7c286a879ca083ef4a0f6f.svg";
export { ForwardRef as ReactComponent };